import { ParamIds, Places } from 'src/Constants'
import IntegracaoMonitoramentoKeys from '../integracao-monitoramento.keys'

export class ResultadoAnaliseVisaoCedenteKeys extends IntegracaoMonitoramentoKeys {
    get place() {
        return Places.mcResultadoAnaliseVisaoCedente
    }

    get visaoCedenteId() {
        return this._intent.getParameterAsNumber(ParamIds.mcResultVisaoCedenteId)
    }

    set visaoCedenteId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcResultVisaoCedenteId, value)
    }
}
